// extracted by mini-css-extract-plugin
module.exports = {"container":"StatusMessage_container__gTrnG","header":"StatusMessage_header__Grfz3","text":"StatusMessage_text__SwNAm","closeButton":"StatusMessage_closeButton__7oh8Y"};